import PropTypes from 'prop-types'
import React from 'react'
import { isEmpty } from 'lodash'
import cx from 'classnames'

import List from 'components/BetterList'
import Button from 'components/Button'
import DateComponent from 'components/Date'
import Reports from 'components/Reports'
// very odd way of doing things, but unable to return multiple rows for a single row otherwise..
import BeforeRow from 'components/Orders/List/BeforeRow'
import AfterRow from 'components/Orders/List/AfterRow'

import printHelper from 'helpers/print'
import moment, { displayFormat } from 'helpers/moment'
import { differentCollections } from 'helpers/index'
import { getBins } from 'helpers/orders'

import { add as addNotification } from 'store/reducers/notifications'
import { show, hide } from 'store/reducers/modals'

import classes from './Process.scss'
import listClass from 'components/BetterList/List.scss'

import MdClear from 'react-icons/lib/md/clear'
import MdCheck from 'react-icons/lib/md/check'
import MdPrint from 'react-icons/lib/md/print'
import MdLabel from 'react-icons/lib/md/label'

export class Process extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      markedPrinted: false, // don't do modals anymore
      reportOrders: [],
      reportReports: [],
      filteredOrders: []
    }
  }

  handleOpenModal = () => {
    this.props.dispatch(show('print', { successCallback: this.markPrinted }))
  };

  handleCloseModal = () => {
    this.props.dispatch(hide('print'))
  };

  markPrinted = e => {
    e.preventDefault()
    this.handleCloseModal(e)
    this.props.markPrinted(this.getOrders())
    this.setState({ markedPrinted: true })
  };

  markNotPrinted = e => {
    e.preventDefault()
    this.props.markNotPrinted(this.getOrders())
    this.setState({ markedPrinted: false })
  };

  getInvoiceCount = (orders = []) => {
    return [...new Set(orders.map(o => o.customer_id))].length
  };

  getLabelsCount = (orders = []) => {
    let count = 0
    orders.forEach(order => {
      let bins = getBins(order)
      count += bins && bins.length
       ? bins.length
       : 1
    })

    return count
  };

  /** Pass in an `order` to mark it as packed! */
  openPackItemModal = (order) => {
    return e => {
      e.preventDefault()

      this.props.dispatch(show('packItem', {
        successCallback: this.closePackItemModal,
        props: { order: order }
      }))
    }
  };

  closePackItemModal = () => {
    this.props.dispatch(hide('packItem'))
  }

  /**
   * @param {Object} input 
   * @param {string[]} [input.reports = []] - The reports to print
   * @param {number} [input.customer_id] - Find orders by customer id
   * @param {number[]} [input.order_ids] - Filter orders by their order id
   */
  print = (input = {}) => {
    return e => {
      e.preventDefault()

      let orders = this.getOrders() || []
      let reports = input.reports

      if (input.customer_id) {
        orders = this.getOrdersByCustomer(input.customer_id)
      } else if (input.order_ids) {
        // Give us an `O(1)` lookup below:
        const orderIdsIndexedObject = input.order_ids.reduce(
          (acc, id) => ({ ...acc, [id]: true }),
          {}
        )

        // Only keep orders that are in the 
        orders = orders.filter(order => {
          return orderIdsIndexedObject[order.id]
        })

        console.log('@@order_ids', input.order_ids.length, orders.length, JSON.stringify(input.order_ids), JSON.stringify(orders.map(o => o.id)))
      }
      

      if (!orders) orders = this.getOrders() || []
      if (!reports) reports = []

      const afterStateChange = async () => {
        window.setTimeout(async () => {
          let success = await printHelper({
            orders,
            reports
          })

          if (success &&
            orders.filter(o => o.printed_at === null).length && // has orders to mark
            !this.state.markedPrinted && // not already marked
            (reports.includes('packlists') || reports.includes('labels')) // only for invoices or labels
          ) {
            this.handleOpenModal()
          }

          if (!success) {
            this.props.dispatch(addNotification('There was an error printing, make sure everything printed.'))
          }
        },
          orders.length * 7.5 || 250 // adds a delay to printing based on the amount of orders
        )
      }

      this.setState({ reportOrders: orders, reportReports: reports }, afterStateChange)
    }
  };

  sortGroup = (a, b) => { // needs to access the first model!
    if (a[0].printed_at === null) return -1
    if (b[0].printed_at === null) return 1
    return 0
  };

  sortList = (a, b) => { // route > customer > product
    return a.route.name.localeCompare(b.route.name) ||
      a.customer.name.localeCompare(b.customer.name) ||
      a.product.name.localeCompare(b.product.name)
  };

  onFilterCallback = filteredOrders => {
    // if not different from current filteredOrders (using id as the only level of validity), stop here
    if (!differentCollections(this.state.filteredOrders, filteredOrders)) return

    this.setState({ filteredOrders })
  };

  getRowLink = order => {
    return `/orders/${order.id}/edit/`
  };

  getRowOptions = order => {
    let array = []
    array.push(order.printed_at ? 'printed' : 'unprinted')
    array.push(order.last_packed_at ? 'packed' : 'unpacked')

    if (this.props.pricelist && this.props.pricelist.length) {
      let found = this.props.pricelist.find(o => o.product_id === order.product_id)

      if (!found || !found.enabled) array.push('error') // not found in pricelist or disabled
    }

    return array
  };

  getRowColumns = (order, index, array) => {
    let isFirstOfCustomer = !array[index - 1] || // no previous order
      order.customer_id !== array[index - 1].customer_id // current order !== previous order's customer

    let columns = []

    columns.push(isFirstOfCustomer && [
      <Button options={['purple', 'icon']}
        callback={this.print({
          customer_id: order.customer_id, // we grab all orders for the customer
          reports: ['packlists']
        })}
      >
        <MdPrint />
      </Button>
    ] || null)

    columns.push([
      <Button options={['small', 'icon']}
        callback={this.print({
          order_ids: [order.id], // we pass a reference so we get the latest data when we print
          reports: ['labels']
        })}
        onlyOnce={false}
      >
        <MdLabel />
      </Button>
    ])

    columns.push(isFirstOfCustomer && [
      <span className={listClass['column--bold']} title={order.route.name}>{order.customer.name}</span>,
    ] || null)

    columns.push([
      <span className={listClass['column--bold']}>{order.product.name}</span>,
      <span className={listClass['column--unimportant']}>{order.product.sourcing_location}</span>
    ])

    columns.push([
      <span>
        <strong>{order.qty}</strong> {order.uom.shorthand || order.uom.name}
      </span>,
      order.option && order.option.name // may not have an option
    ])

    columns.push([
      order.packed_qty && <span>
        <strong>{order.packed_qty}</strong>
        {' '}{order.packed_uom && (order.packed_uom.shorthand || order.packed_uom.name)}
        {' '}
      </span>
      ,
      <Button
        options={[order.packed_qty ? 'grey' : 'green', 'small']}
        callback={this.openPackItemModal(order)}
        onlyOnce={false} // we can pack => edit => edit multiple times
      >
        {order.packed_qty ? 'edit' : 'pack item'}
      </Button>
    ])

    return columns
  };

  getOrders = () => {
    if (this.state.filteredOrders.length) return this.state.filteredOrders
    if (this.props.orders.length) return this.props.orders
    return []
  };

  getOrdersByCustomer = customerId => {
    return this.getOrders().filter(order => order.customer_id === customerId)
  };

  render () {
    const headers = ['', '', 'customer', 'product', 'qty', 'packing']
    const columnOptions = ['minimal', 'minimal', null, null, 'center', 'minimal']

    let inValidOrders = 0 // a count of disabled or not on pricelist products
    if (this.props.pricelist.length) {
      this.getOrders().map(o => o.product_id).forEach(productId => {
        let product = this.props.pricelist.find(p => p.product_id === productId)
        if (!productId || !product || !product.product_id) return (inValidOrders += 1) // can't find an order's product in current pricelist

        inValidOrders += !product.enabled // !true = 0, !false = 1, so adds 1 if enabled = false.
      })
    }

    return <div className={classes.collection}>
      <header className={cx(classes['header'], classes['header--large'])}>
        <div className={classes['header-title']}>
          Fulfill Orders
          <span className={classes['header-title--sub']}>
            <DateComponent {...this.props}
              date={this.props.date}
              textFormat='fulfill on {0}'
              baseUrl='process'
            />
          </span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['red', 'small']}
            callback={this.print({ reports: ['shellfishpicklists', 'smallfishpicklists'] })}
          >
            <MdPrint /> Picklists
          </Button>

          <Button
            options={['purple', 'small']}
            callback={this.print({ reports: ['shellfishsaleslogs'] })}
          >
            <MdPrint /> Shellfish Sales Log
          </Button>
        </div>

        {!!this.getOrders().filter(o => o.printed_at === null).length && <div className={classes['header-buttons']}>
          <Button options={['green']} callback={this.markPrinted}>
            <MdCheck /> Mark All Orders Printed
          </Button>
        </div>}

        {!!inValidOrders && <div className={classes['header--error']}>
          There {inValidOrders > 1 && 'are' || 'is'} <strong>{inValidOrders}</strong> order{inValidOrders > 1 && 's' || ''}
          &nbsp;with products not on this day's pricelist marked in red below.
        </div>}
      </header>

      <List
        collection={this.props.orders}
        columnOptions={columnOptions}
        headers={headers}

        stripeByField={'customer_id'}

        renderAfterRow={AfterRow}
        renderBeforeRow={BeforeRow}
        getRowLink={this.getRowLink}
        getRowOptions={this.getRowOptions}
        getRowColumns={this.getRowColumns}
        sort={this.sortList}

        groupBy={(o) => !!o.printed_at}
        groupTitle={(o, i, c) => o[0] && o[0].printed_at && 'Printed' || 'Unprinted'}
        groupDesc={(o, i, c) => {
          return <div>
            <Button options={['blue', 'small', 'auto-space']}
              callback={this.print({
                order_ids: o.map(i => i.id), // we pass a reference so we get the latest data when we print
                reports: ['packlists']
              })}
            >
              <MdPrint /> Invoices ({this.getInvoiceCount(o)})
            </Button>

            <Button options={['white', 'small', 'auto-space']}
              callback={this.print({
                order_ids: o.map(i => i.id), // we pass a reference so we get the latest data when we print
                reports: ['labels']
              })}
            >
              <MdLabel /> Labels ({this.getLabelsCount(o)})
            </Button>

            {o.find(o => o).printed_at && <Button options={['red', 'small', 'auto-space']} callback={this.markNotPrinted}>
              <MdClear /> Mark Not Printed
            </Button>}
          </div>
        }}
        sortGroup={this.sortGroup}
        filter={['product.name', 'customer.name', 'route.name', 'product.type.name', '__options']}
        quickFilters={['unprinted', 'printed', 'error', 'packed', 'unpacked']}
        filterPlaceholder='search orders'
        onFilterCallback={this.onFilterCallback}

        noResultsText={`No orders for ${moment(this.props.date).format(displayFormat)}.`}
      />

      {!isEmpty(this.state.reportOrders) &&
        <Reports orders={this.state.reportOrders} reports={this.state.reportReports} />
      }
    </div>
  }
}

Process.propTypes = {
  pricelist: PropTypes.array,
  orders: PropTypes.array.isRequired,
  routes: PropTypes.array,
  customers: PropTypes.array,
  options: PropTypes.array,
  uoms: PropTypes.array,

  date: PropTypes.any,
  markPrinted: PropTypes.func.isRequired,
  markNotPrinted: PropTypes.func.isRequired,

  params: PropTypes.object,
  location: PropTypes.object,
  dispatch: PropTypes.func.isRequired
}

export default Process



// WEBPACK FOOTER //
// ./src/components/Orders/Process/Process.js